import { createAction, props } from '@ngrx/store';

export const ActionTypes = {
    SET_LOADED_STATUS: '[checkout-navigation] SET_LOADED_STATUS', // navigation is ready
    SET_LOADING_STATUS: '[checkout-navigation] SET_LOADING_STATUS', // set loading in button
    SET_PENDING_STATUS: '[checkout-navigation] SET_PENDING_STATUS', // user needs to interact to continue
    SET_NEXT_STATUS: '[checkout-navigation] SET_NEXT_STATUS', // user can continue in the checkout
    SET_VISIBLE_BUTTON: '[checkout-navigation] SET_VISIBLE_BUTTON', // show button to continue
    SET_INVISIBLE_BUTTON: '[checkout-navigation] SET_INVISIBLE_BUTTON', // hide button to continue
    SET_SAVE_BUTTON: '[checkout-navigation] SET_SAVE_BUTTON', // set button to save
    SET_CONTINUE_BUTTON: '[checkout-navigation] SET_CONTINUE_BUTTON', // set button to continue
    SET_ACTIVE_BUTTON: '[checkout-navigation] SET_ACTIVE_BUTTON', // set button active
    SET_INACTIVE_BUTTON: '[checkout-navigation] SET_INACTIVE_BUTTON', // set button inactive
    INIT_BUTTON: '[checkout-navigation] INIT NAVIGATION BUTTON',
    SET_USER_ACTUAL_STEP: '[router] SET_USER_ACTUAL_STEP',
    INITIAL_LOAD: '[navigation] INITIAL_LOAD',
    SET_ACTIVE_STEP: '[navigation] SET_ACTIVE_STEP',
};

export const SetLoadedStatus = createAction(ActionTypes.SET_LOADED_STATUS);
export const SetLoadingStatus = createAction(ActionTypes.SET_LOADING_STATUS);
export const SetPendingStatus = createAction(ActionTypes.SET_PENDING_STATUS);
export const SetNextStatus = createAction(ActionTypes.SET_NEXT_STATUS);

export const SetVisibleButton = createAction(ActionTypes.SET_VISIBLE_BUTTON);
export const SetInvisibleButton = createAction(ActionTypes.SET_INVISIBLE_BUTTON);
export const SetActiveButton = createAction(ActionTypes.SET_ACTIVE_BUTTON);
export const SetInactiveButton = createAction(ActionTypes.SET_INACTIVE_BUTTON);

export const InitButton = createAction(ActionTypes.INIT_BUTTON);

export const SetSaveButton = createAction(ActionTypes.SET_SAVE_BUTTON);
export const SetContinueButton = createAction(ActionTypes.SET_CONTINUE_BUTTON);

export const SetActivePath = createAction(ActionTypes.SET_ACTIVE_STEP, props<{ path: string }>());
